export default __webpack_public_path__ + "static/media/ico_checkbox_true.c6a62ab7.svg";